import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";

const handleFetchBrands = async ({ page, limit }: any) => {
  const uri = `v1/brands?page=${page}&limit=${limit}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateBrand = async (data: any) => {
  const uri = `v1/brands`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateBrand = async ({ _id, data }: any) => {
  const uri = `v1/brands/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteBrand = async (data: any) => {
  const uri = `v1/brands`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchBrands,
  handleCreateBrand,
  handleUpdateBrand,
  handleDeleteBrand,
};
